import React, { useState } from 'react';
import classnames from 'classnames';
import { Button, Input } from 'tea-component';

import type { IBaseProps } from '@home/types/common';

import '@gp/pages/Pipeline/ProjectDetails/Milestone/components/RenameBox/index.scss';

type IEmmiter = (payload: string) => void;

interface IRenameBoxProps extends IBaseProps {
  value: string;
  onChange?: IEmmiter;
  onConfirm?: IEmmiter;
  onCancel?: IEmmiter;
  onClose?: IEmmiter;
}

const RenameBox: React.FC<IRenameBoxProps> = (props) => {
  const {
    style,
    className,
    value: valueProps,
    onChange,
    onConfirm,
    onCancel,
    onClose,
  } = props;

  const [value, setValue] = useState<string>(valueProps);

  return (
    <div
      style={style}
      className={classnames('dialog-rename-box dbg-rename-box', className)}
    >
      <div className="dialog-rename-box-hd">
        <h3 className="dialog-rename-box-title">Rename</h3>
        <Button
          icon="close"
          onClick={(e) => {
            e?.stopPropagation();
            onClose?.(value?.trim() || '');
          }}
        />
      </div>
      <div className="dialog-rename-body">
        <Input
          className="dialog-rename-text"
          value={value}
          onChange={(payload) => {
            setValue(payload);
            onChange?.(payload);
          }}
          placeholder={'Please input file name'}
        />
      </div>
      <div className="dialog-rename-footer">
        <Button
          type="primary"
          onClick={(e) => {
            e?.stopPropagation();
            onConfirm?.(value?.trim() || '');
          }}
          disabled={value === ''}
        >
          Confirm
        </Button>
        <Button
          type="weak"
          onClick={(e) => {
            e?.stopPropagation();
            onCancel?.(value?.trim() || '');
          }}
        >
          Cancel
        </Button>
      </div>
    </div>
  );
};

export default RenameBox;
